export default "__VITE_ASSET__CkEpleGG__"